if (!customElements.get('nomitail-header-search')) {
  customElements.define('nomitail-header-search', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      const toggle = this.querySelector('[data-search-toggle]');
      const form = this.querySelector('.ella-style-header__search');
      const input = form?.querySelector('input[name="q"]');
      const close = this.querySelector('[data-search-close]');
      if (!toggle || !form || !input || !close) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const mobile = window.matchMedia('(max-width: 989px)');
      const setOpen = (open, restoreFocus = false) => {
        this.classList.toggle('is-search-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close search' : 'Open search');
        if (open) input.focus({ preventScroll: true });
        else if (restoreFocus && mobile.matches) toggle.focus({ preventScroll: true });
      };

      toggle.addEventListener('click', () => {
        if (!mobile.matches) return;
        setOpen(!this.classList.contains('is-search-open'), true);
      }, options);

      close.addEventListener('click', () => setOpen(false, true), options);

      form.addEventListener('submit', (event) => {
        if (!input.value.trim()) {
          event.preventDefault();
          if (mobile.matches) setOpen(true);
          else input.focus();
          return;
        }
        input.value = input.value.trim();
      }, options);

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.classList.contains('is-search-open')) return;
        setOpen(false, true);
        event.preventDefault();
      }, options);

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) setOpen(false);
      }, options);

      mobile.addEventListener('change', () => setOpen(false), options);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
